export const state = () => ({
    creditTiers: [],
    itemTiers: [],
    rewards: {},
    rewardsLoading: {},
    exchangeRewardTermAndCondition: {},
    rewardHistories: { data: [] },
    coinHistories: { data: [] },
    getAllTiersLoading: {},
})

export const actions = {
    // Get tiers
    async getAllTiers({ commit }, params) {
        commit('setGetAllTiersLoading', { [params.reward_type]: true })
        await this.$axios
            .get('/exchange-rewards/tiers', { params })
            .then((data) => {
                if (params.reward_type === 1)
                    commit('setCreditTiers', data?.data?.data)
                if (params.reward_type === 2)
                    commit('setItemTiers', data?.data?.data)
            })
            .catch((_) => {
                return false
            })
        commit('setGetAllTiersLoading', { [params.reward_type]: false })
    },
    async getTierRewards({ commit }, params) {
        commit('setRewardsLoading', { [params.tier_id]: true })
        await this.$axios
            .get('/exchange-rewards', { params })
            .then((data) => {
                commit('setRewards', {
                    [`${params.tier_id}:${params.reward_type}`]:
                        data?.data?.data,
                })
            })
            .catch((_) => {
                return false
            })
        commit('setRewardsLoading', { [params.tier_id]: false })
    },
    async onClaimReward({ _ }, { rewardId, body }) {
        const response = await this.$axios
            .post(`/exchange-rewards/claim/${rewardId}`, body, {
                params: {
                    hideToast: true,
                },
            })
            .then((data) => {
                return {
                    status: true,
                }
            })
            .catch((error) => {
                return {
                    status: false,
                    code: error.response.data?.code,
                    message: error.response.data?.message,
                }
            })
        return response
    },
    async getExchangeRewardTermAndCondition({ commit }, params) {
        await this.$axios
            .get('/exchange-rewards/tnc', { params })
            .then((data) => {
                commit('setExchangeRewardTermAndCondition', data?.data?.data)
            })
            .catch((_) => {
                return false
            })
    },
    async getRewardHistories({ commit }, data) {
        const params = { ...data }
        if (params.status && params?.status?.length > 0) {
            params.status = JSON.stringify(data.status)
        } else {
            delete params.status
        }
        await this.$axios
            .get('/rewards-history', { params })
            .then((data) => {
                commit('setRewardHistories', data?.data)
            })
            .catch((_) => {
                return false
            })
    },
    async getCoinHistories({ commit }, params) {
        await this.$axios
            .get('/coin-history', { params })
            .then((data) => {
                commit('setCoinHistories', data?.data)
            })
            .catch((_) => {
                return false
            })
    },
}

export const mutations = {
    setCreditTiers: (state, data) => {
        state.creditTiers = data
    },
    setItemTiers: (state, data) => {
        state.itemTiers = data
    },
    setRewards: (state, data) => {
        const rewards = {
            ...state.rewards,
            ...data,
        }
        state.rewards = rewards
    },
    setRewardsLoading: (state, data) => {
        const rewardsLoading = {
            ...state.rewardsLoading,
            ...data,
        }
        state.rewardsLoading = rewardsLoading
    },
    setExchangeRewardTermAndCondition: (state, data) => {
        state.exchangeRewardTermAndCondition = data
    },
    setRewardHistories: (state, data) => {
        state.rewardHistories = data
    },
    setCoinHistories: (state, data) => {
        state.coinHistories = data
    },
    setGetAllTiersLoading: (state, data) => {
        const getAllTiersLoading = {
            ...state.getAllTiersLoading,
            ...data,
        }
        state.getAllTiersLoading = getAllTiersLoading
    },
}
